import React from "react";
import styled from "styled-components";
import pettineeIcon from "../../../img/pettinee_circle.png";
import { Image } from "react-bootstrap";

export const Logo = styled.div`
  color: #fff;
  display: flex;
  height: 50px;
  width: fit-content;
  align-items: center;
  
  opacity: ${(props: { showsidebar?: boolean }) =>
    props.showsidebar ? "1" : "0"};
  pointer-events: none;
`;
export const LogoName = styled.div`
  font-size: 20px;
  font-weight: 400;
`;
export const ImageLogo = styled(Image)`
  margin-right: 0.5rem;
`;
const LogoPettinee = ({ showsidebar }: { showsidebar?: boolean }) => {
  return (
    <Logo showsidebar={showsidebar}>
      <ImageLogo alt="menu-more" src={pettineeIcon} width={32} height={32} />
      <LogoName>Pettinee</LogoName>
    </Logo>
  );
};

export default LogoPettinee;
